import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'adas',
  table: 'incidents_types',
  title: 'Типы инцидентов ADAS',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'incident_type',
      title: 'Код инцидента',
      type: 'number',
      required: true,
      maxLengthValue: 8
    },
    {
      name: 'incident_name',
      title: 'Название',
      type: 'text',
      required: true,
      maxLengthValue: 256
    },
    {
      name: 'incident_short_name',
      title: 'Краткое название',
      type: 'text',
      maxLengthValue: 32
    },
    {
      name: 'incident_color',
      title: 'Цвет',
      type: 'color',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    incident_type: null,
    incident_name: '',
    incident_short_name: '',
    incident_color: "#000000",
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  updateInStore: true,
  export: {
    fields: [
      {
        name: 'incident_type',
        title: 'Код инцидента',
      },
      {
        name: 'incident_name',
        title: 'Название',
      },
      {
        name: 'incident_short_name',
        title: 'Краткое название',
      },
      {
        name: 'incident_color',
        title: 'Цвет',
      }
    ]
  }
};

export default config;